import { createFileRoute, redirect } from '@tanstack/react-router';

// DEC-011: SSO & SCIM configuration was folded into the Organization settings
// page (committed 700d5fba1). This redirect lands users on the page that now
// hosts what they were looking for, preserving old admin bookmarks.
export const Route = createFileRoute('/$organizationName/settings/sso-scim')({
  component: () => null,
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/$organizationName/settings/organization',
      params: { organizationName: params.organizationName },
    });
  },
});
